import React from 'react'

export default function Project_overview() {
  return (
    <div>
      <div class="project-page">

  
    <section class="project-header">

        <div class="project-icon">
            <span>▣</span>
        </div>

        <div class="project-title">
            <div class="back-link">← Back to Projects</div>

            <h1>E-Commerce Website</h1>

            <p>
                A modern e-commerce website with product listing,
                shopping cart, payment integration and admin panel.
            </p>
        </div>

        <div class="project-meta">

            <div>
                <span>Project ID</span>
                <strong>#PRJ-001</strong>
            </div>

            <div>
                <span>Created On</span>
                <strong>Sep 15, 2026</strong>
            </div>

            <div>
                <span>Status</span>
                <strong class="status-active">Active</strong>
            </div>

        </div>

        <button class="edit-project">
            ✎ View / Edit Project
        </button>

    </section>


   
    <section class="ai-header">

        <div>
            <h2>
                ✨ AI Project Analysis
                <span>Generated by Gemini</span>
            </h2>

            <p>
                Technical analysis and implementation guidelines
                generated from the project requirements.
            </p>
        </div>

        <button class="copy-button">
            ⧉ Copy
        </button>

    </section>


   
    <nav class="analysis-tabs">

        <button class="active">Overview</button>
        <button>Technology Stack</button>
        <button>Project Modules</button>
        <button>Database Structure</button>
        <button>SEO Requirements</button>
        <button>Development TODO</button>
        <button>Guidelines</button>
        <button>Development Order</button>

    </nav>


    

    <div class="overview-grid">


       
        <section class="content-card">

            <div class="card-heading">
                <span class="card-icon">▤</span>

                <div>
                    <h3>Project Overview</h3>
                    <p>Purpose and general description</p>
                </div>
            </div>

            <p class="description">
                This project is an e-commerce website designed to provide
                a seamless online shopping experience. It will include
                product browsing, secure payment integration, order
                management and an admin panel for store management.
            </p>

        </section>


       
        <section class="content-card">

            <div class="card-heading">
                <span class="card-icon">⌘</span>

                <div>
                    <h3>Recommended Technology Stack</h3>
                    <p>Technologies recommended by Gemini</p>
                </div>
            </div>


            <div class="technology-grid">

                <div class="technology-item">
                    <div class="tech-icon">⚛</div>

                    <div>
                        <strong>Frontend</strong>
                        <p>React.js, HTML5, CSS3, JavaScript</p>
                        <small>Modern and SEO-friendly</small>
                    </div>
                </div>


                <div class="technology-item">
                    <div class="tech-icon">PHP</div>

                    <div>
                        <strong>Backend</strong>
                        <p>PHP / Laravel</p>
                        <small>Secure and scalable</small>
                    </div>
                </div>


                <div class="technology-item">
                    <div class="tech-icon">DB</div>

                    <div>
                        <strong>Database</strong>
                        <p>MySQL</p>
                        <small>Reliable relational database</small>
                    </div>
                </div>


                <div class="technology-item">
                    <div class="tech-icon">API</div>

                    <div>
                        <strong>Payment</strong>
                        <p>Stripe / PayPal</p>
                        <small>Secure payment processing</small>
                    </div>
                </div>

            </div>

        </section>

    </div>


    

    <section class="content-card full-width">

        <div class="card-heading">

            <span class="card-icon">▦</span>

            <div>
                <h3>Project Modules</h3>
                <p>Major modules identified from the requirements</p>
            </div>

        </div>


        <div class="module-grid">

            <div class="module-card">

                <div class="module-number">01</div>

                <h4>User Authentication</h4>

                <p>
                    Handles user registration, login and password
                    management.
                </p>

                <strong>Key Features</strong>

                <ul>
                    <li>Sign up / Login</li>
                    <li>Password reset</li>
                    <li>Role-based access</li>
                </ul>

            </div>


            <div class="module-card">

                <div class="module-number">02</div>

                <h4>Product Management</h4>

                <p>
                    Manage products, categories, brands and inventory.
                </p>

                <strong>Key Features</strong>

                <ul>
                    <li>Add / Edit products</li>
                    <li>Category management</li>
                    <li>Stock tracking</li>
                </ul>

            </div>


            <div class="module-card">

                <div class="module-number">03</div>

                <h4>Shopping Cart</h4>

                <p>
                    Allows customers to add products and complete
                    purchases.
                </p>

                <strong>Key Features</strong>

                <ul>
                    <li>Cart management</li>
                    <li>Checkout</li>
                    <li>Order confirmation</li>
                </ul>

            </div>


            <div class="module-card">

                <div class="module-number">04</div>

                <h4>Admin Panel</h4>

                <p>
                    Provides administrators with complete store
                    management.
                </p>

                <strong>Key Features</strong>

                <ul>
                    <li>Order management</li>
                    <li>User management</li>
                    <li>Reports</li>
                </ul>

            </div>

        </div>

    </section>


  

    <div class="bottom-grid">


      

        <section class="content-card">

            <div class="card-heading">

                <span class="card-icon">DB</span>

                <div>
                    <h3>Database Structure</h3>
                    <p>Important tables and relationships</p>
                </div>

            </div>


            <div class="table-wrapper">

                <table>

                    <thead>
                        <tr>
                            <th>Table</th>
                            <th>Purpose</th>
                            <th>Key Fields</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td><strong>users</strong></td>
                            <td>Stores users</td>
                            <td>id, name, email, role_id</td>
                        </tr>

                        <tr>
                            <td><strong>products</strong></td>
                            <td>Stores products</td>
                            <td>id, name, price, category_id</td>
                        </tr>

                        <tr>
                            <td><strong>orders</strong></td>
                            <td>Stores orders</td>
                            <td>id, user_id, total, status</td>
                        </tr>

                        <tr>
                            <td><strong>order_items</strong></td>
                            <td>Order products</td>
                            <td>order_id, product_id, quantity</td>
                        </tr>

                    </tbody>

                </table>

            </div>

        </section>


       

        <section class="content-card">

            <div class="card-heading">

                <span class="card-icon">⌕</span>

                <div>
                    <h3>SEO Requirements</h3>
                    <p>Recommended search optimization</p>
                </div>

            </div>


            <ul class="seo-list">

                <li>
                    <span>✓</span>
                    Clean and SEO-friendly URLs
                </li>

                <li>
                    <span>✓</span>
                    Unique meta titles and descriptions
                </li>

                <li>
                    <span>✓</span>
                    Proper H1, H2 and H3 structure
                </li>

                <li>
                    <span>✓</span>
                    Schema.org structured data
                </li>

                <li>
                    <span>✓</span>
                    XML sitemap
                </li>

                <li>
                    <span>✓</span>
                    Robots.txt configuration
                </li>

                <li>
                    <span>✓</span>
                    Mobile responsiveness
                </li>

                <li>
                    <span>✓</span>
                    Page speed optimization
                </li>

            </ul>

        </section>

    </div>


   

    <section class="content-card full-width todo-section">

        <div class="card-heading">

            <span class="card-icon">✓</span>

            <div>
                <h3>Development TODO</h3>
                <p>Recommended implementation sequence</p>
            </div>

        </div>


        <div class="todo-list">

            <div class="todo-item completed">
                <span class="checkbox">✓</span>
                <div>
                    <strong>Define project architecture</strong>
                    <p>Finalize frontend, backend and database architecture.</p>
                </div>
            </div>


            <div class="todo-item">
                <span class="checkbox"></span>
                <div>
                    <strong>Create database structure</strong>
                    <p>Create required tables and establish relationships.</p>
                </div>
            </div>


            <div class="todo-item">
                <span class="checkbox"></span>
                <div>
                    <strong>Implement authentication</strong>
                    <p>Create registration, login and password recovery.</p>
                </div>
            </div>


            <div class="todo-item">
                <span class="checkbox"></span>
                <div>
                    <strong>Develop product management</strong>
                    <p>Create product CRUD and inventory management.</p>
                </div>
            </div>


            <div class="todo-item">
                <span class="checkbox"></span>
                <div>
                    <strong>Implement shopping cart and checkout</strong>
                    <p>Develop cart, checkout and payment integration.</p>
                </div>
            </div>

        </div>

    </section>


</div>
    </div>
  )
}
